import { Util } from "@xt/xtbase";
import { refStructEnhancer } from "mobx/dist/internal";
import { HighlightSpanKind } from "typescript";
const { Big, moment } = Util;
moment.locale("en");
export class VipInfoObj {
    [x: string]: any;
    constructor(v) {
        this.curLevelNum = v?.vipLevel;
        this.curLevelName = v?.vipName || "";
        this.nextLevelName = v?.nextLevelName;
        this.tradeVolume = !isNaN(+v?.tradeLeastAmount) ? +v?.tradeLeastAmount : 0;
        // this.tradeVolume = !v?.tradeLeastAmount && v?.tradeLeastAmount != 0 ? "--" : Big(+v?.tradeLeastAmount).toFixedMaxCy(8); // 下一级需要达到的30日交易量
        this.xtVolume = !isNaN(+v?.balanceLeastAmount) ? +v?.balanceLeastAmount : 0;
        // this.xtVolume = !v?.balanceLeastAmount && v?.balanceLeastAmount != 0 ? "--" : Big(+v?.balanceLeastAmount).toFixedMaxCy(8); // 下一级需要达到的24小时xt平均持有量
        this.userTradeValue = +v?.nextLevelName; // 30天交易量
        this.userXtVolume = +v?.userXtVolume;// 24小时xt平均持有量
        this.makerFeeRate = !isNaN(+v?.makerFeeRate) ? Big(+v?.makerFeeRate).times(100).toFixedCy(4) : "--";
        this.takerFeeRate = !isNaN(+v?.takerFeeRate) ? Big(+v?.takerFeeRate).times(100).toFixedCy(4) : "--";
        this.nextLevelMakerRate = v?.nextLevelMakerRate || "--";
        this.nextLevelTakerRate = v?.nextLevelTakerRate || "--";
        this.isNormalVip = !v?.type;
        this.isMaxVip =  v?.isMaxVip || false;
    }
    get tradeVolumeStr(): string {
        if (isNaN(+this.tradeVolume) || this.tradeVolume<=0) return "0";
        return Big(this.tradeVolume).toFixedMaxCy(8);
    }
    get xtVolumeStr(): string {
        if (isNaN(+this.xtVolume) || this.xtVolume<=0) return "0";
        return Big(this.xtVolume).toFixedMaxCy(8)
    }
    get userTradeValueStr(): string {
        if (isNaN(+this.userTradeValue) || this.userTradeValue<=0) return "0";
        return Big(this.userTradeValue).toFixedMaxCy(8);
    }
    get userTradeRate(): number {
        if (isNaN(+this.tradeVolume) || isNaN(+this.userTradeValue) || this.tradeVolume<=0) return 0;
        return +(Big(+this.userTradeValue).div(this.tradeVolume).times(100));
    }
    get userXtVolumeStr(): string {
        if (isNaN(+this.userXtVolume) || this.userXtVolume<=0) return "0";
        return Big(this.userXtVolume).toFixedMaxCy(8)
    }
    get userXtVolumeRate(): number {
        if (isNaN(+this.xtVolume) || this.xtVolume<=0 || isNaN(+this.userXtVolume)) return 0;
        return +(Big(this.userXtVolume).div(this.xtVolume).times(100));
    }
    get userLastTradeValue(): string {
        if (isNaN(+this.tradeVolume) || this.tradeVolume<=0) return "0";
        if (isNaN(+this.userTradeValue))  return Big(this.tradeVolume).toFixedMaxCy(8);
        const result = Big(this.tradeVolume).minus(this.userTradeValue);
        if (+result < 0) return "0";
        return result.toFixedMaxCy(8);
    }
    get userLastXtVolume(): string {
        
        if (isNaN(+this.xtVolume) || this.xtVolume<=0) return "0";
        if (isNaN(+this.userXtVolume)) return Big(+this.xtVolume).toFixedMaxCy(8);
        const result = Big(+this.xtVolume).minus(+this.userXtVolume);
        if (+result < 0) return "0";
        return result.toFixedMaxCy(8);
    }
    set setNextLevelName(str: string) {
        this.nextLevelName = str;
    }
    set setNormalVip(flag: boolean) {
        this.isNormalVip = flag;
    }
    set setTradeVolume(val: string) {
        this.tradeVolume = val;
    }
    set setXtVolume(val: string) {
        this.xtVolume = val;
    }
    set setRateType(val: number) {
        this.rateType = val;
    }
    set setUserTradeValue(val: number) {
        this.userTradeValue = val; 
    }
    set setUserXtVolume(val: number) {
        this.userXtVolume = val;
    }
    set setIsMaxVip(val: boolean) {
        this.isMaxVip = val;
    }
    set setNextLevelMakerRate(val: string) {
        this.nextLevelMakerRate = val;
    }
    set setNextLevelTakerRate(val: string) {
        this.nextLevelTakerRate = val;
    }
}

export class FuVipInfoObj {
    [x: string]: any
    constructor(v) {
        this.levelName = "";
        this.nextLevelName = "--";
        this.discountLevel = v?.discountLevel;
        this.totalTradeVolume = v?.totalTradeVolume;
        this.ubasedTotalTradeVolume = v?.ubasedTotalTradeVolume;
        this.coinBasedTotalTradeVolume = v?.coinBasedTotalTradeVolume;
        this.levelReturnDay = v?.levelReturnDay;
        this.makerFee = v?.makerFee;
        this.takerFee = v?.takerFee;
        this.nextLvMakerFee = v?.nextLvMakerFee;
        this.nextLvTakerFee = v?.nextLvTakerFee;
        this.lackTradeVolume = v?.lackTradeVolume;
        this.nextLvTradeVolume = v?.nextLvTradeVolume;
        this.specialType = v?.specialType;

        this.id = v?.id;
        this.stepName = v?.stepName;
        this.tradeVolume = v?.tradeVolume;
    }
    
    get nextLevelMakerRate() {
        return !isNaN(+this.nextLvMakerFee) ? Big(+this.nextLvMakerFee).times(100).toFixedCy(4) : "--";
    }

    get nextLevelTakerRate() {
        return !isNaN(+this.nextLvTakerFee) ? Big(+this.nextLvTakerFee).times(100).toFixedCy(4) : "--";
    }

    get tradeVolumeStr(): string {
        if (isNaN(+this.tradeVolume) || this.tradeVolume<=0) return "0";
        return Big(this.tradeVolume).toFixedMaxCy(8);
    }

    get tradeRadioNum() {
        if (isNaN(+this.totalTradeVolume) || this.totalTradeVolume<=0) return 0;
        const progressBN = Big(this.totalTradeVolume).div(this.nextLvTradeVolume);
        return  progressBN.gte(1) ? 100 : +(progressBN.times(100));
    }

    set setLevelName(str: string) {
        this.levelName = str;
    }

    set setNextLevelName(str: string) {
        this.nextLevelName = str;
    };

    get totalTradeVolumeStr() {
        if (isNaN(+this.totalTradeVolume) || this.totalTradeVolume<=0) return "0";
        return Big(this.totalTradeVolume).toFixedMaxCy(8);
    }

    get nextLvTradeVolumeStr() {
        if (isNaN(this.nextLvTradeVolume) || this.nextLvTradeVolume<=0) return "0";
        return Big(this.nextLvTradeVolume).toFixedMaxCy(8);
    }

    get lackTradeVolumeStr() {
        if (isNaN(+this.lackTradeVolume) || this.lackTradeVolume<=0) return "0";
        return Big(this.lackTradeVolume).toFixedMaxCy(8);
    }

    get userLastTradeVolume() {
        if (isNaN(this.nextLvTradeVolume) || this.nextLvTradeVolume<=0) return "0";
        if (isNaN(this.userTradeValue)) return Big(this.nextLvTradeVolume).toFixedMaxCy(8);
        const result = Big(this.nextLvTradeVolume).minus(this.userTradeValue);
        if (+result < 0) return "0";
        return result.toFixedMaxCy(8);
    }

    get makerFeeStr() {
        return !isNaN(+this.makerFee) ? Big(this.makerFee).times(100).toFixedCy(4) : "--";
    }

    get takerFeeStr() {
        return !isNaN(+this.takerFee) ? Big(this.takerFee).times(100).toFixedCy(4) : "--";
    }

    get isMaxVip() {
        if (this.levelName === "--") return false;
        return this.levelName === this.nextLevelName;
    }
}

export class Record {
    [x:string]: any;
    constructor(r) {
        this.date = moment(r?.statsTime).format('YYYY-MM-DD');
        this.ubasedTradeVolume = !isNaN(+r?.ubasedTradeVolume) ? Big(+r?.ubasedTradeVolume).toFixedMaxCy(8) : 0;
        this.coinBasedTradeVolume = !isNaN(+r?.coinBasedTradeVolume) ? Big(+r?.coinBasedTradeVolume).toFixedMaxCy(8) : 0;
        this.totalTradeVolume = !isNaN(+r?.totalTradeVolume) ? Big(+r?.totalTradeVolume).toFixedMaxCy(8) : 0;
    }
}
